export default function GlobalDebug(environment) {

    if (environment === 'production') {
        console.log = () => {}
        console.warn = () => {}
        console.info = () => {}
        console.error = () => {}
    }
}